import React from 'react'
import _ from 'lodash'

import { Standard } from './Standard'
import * as Validations from 'base/control/validations'

export type EmailProps = React.ComponentProps<typeof Standard>

export const Email: React.FC<EmailProps> = props => {
  const { validate } = props

  const handleEdit = (value: string): string | null => {
    return value
  }

  return (
    <Standard
      {...props}
      type='text'
      editValue={handleEdit}
      validate={_.assign({}, validate, { email: Validations.email })}
    />
  )
}

export default Email
